import { AuthActionType } from '../context/actions';
import { useAuthContext } from '../context/context';
import { AuthScreen, OTPMethod, RegisterDataType } from '../context/reducer';

interface UseAuthResponse {
  authScreen: AuthScreen;
  setAuthScreen: (authScreen: AuthScreen) => void;
  registerData: RegisterDataType;
  setContextData: (props: RegisterDataType) => void;
  otpMethod: OTPMethod;
  setOTPMethod: (otpMethod: OTPMethod) => void;
}

export const useAuth = (): UseAuthResponse => {
  const { authState, authDispatch } = useAuthContext();

  const setContextData = (props: RegisterDataType) => {
    authDispatch({
      type: AuthActionType.SET_REGISTER_DATA,
      payload: { registerData: props },
    });
  };

  const setAuthScreen = (authScreen: AuthScreen) => {
    authDispatch({
      type: AuthActionType.SET_AUTH_SCREEN,
      payload: { authScreen: authScreen },
    });
  };

  const setOTPMethod = (otpMethod: OTPMethod) => {
    authDispatch({
      type: AuthActionType.SET_OTP_METHOD,
      payload: { otpMethod: otpMethod },
    });
  };

  return {
    authScreen: authState.authScreen,
    setAuthScreen: setAuthScreen,
    registerData: authState.registerData,
    setContextData,
    otpMethod: authState.otpMethod,
    setOTPMethod,
  };
};
